// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { FeatureKind } from './feature-kind';
import { Manufacturer } from './manufacturer';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class ManufacturerFeatureKindMap extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  /** Int32 key FK manufacturer */
  manufacturerId!: number;
  /** Int32 key FK featureKind */
  featureKindId!: number;
  /** Int32 */
  requiredCount!: number;
  /** FK featureKindId */
  featureKind!: FeatureKind;
  /** FK manufacturerId */
  manufacturer!: Manufacturer;
}

